import router from '@/router'
import Swal from 'sweetalert2'

const sweetAlert = {
  methods: {
    sweetAlertAfterAdCreation(accountId) {
      Swal.fire({
        title: 'Congratulations!',
        text: 'Your Ad was created succesfully',
        html: 'Your Ad was created succesfully'
                + '<br><br>You will be redirected there in a few seconds',
        icon: 'success',
        confirmButtonText: 'Continue to Statistics',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        timer: 5000,
      }).then(() => {
        const id = accountId || this.$route.params.accountId
        const target = process.env.VUE_APP_REDIRECT_AFTER_AD_CREATION === 'adgroups'
          ? `/${id}/?tab=adgroups`
          : `/${id}/`
        router.push(target)
      })
    },
  },
}

export default sweetAlert
